<template>
  <!-- <div class="pt-4">
        <h1>Bedrijf aanmaken</h1>
        <vs-card class="mt-6" v-if="staffRoute">
            <div slot="header">
                <h2>Legal</h2>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">KVK Nummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="coc" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">BTW Nummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="vat" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">IBAN Nummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="iban" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Statutaire naam</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="legal_name" />
                </div>
            </div>

        </vs-card>
        <vs-card>
            <div slot="header">
                <h2>Standaard</h2>
            </div>

            <div class="vx-row mb-6" v-if="">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Naam</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="name" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Slug</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="slug" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Land</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="country" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Provincie/Staat</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="state" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Stad</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="city" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Straatnaam</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="streetname" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Huisnummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="housenumber" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Postcode</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="postcode" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Email</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="email" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Financieel Email</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="financialemail" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Telefoonnummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="phonenumber" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Intern telefoonnummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="internalphonenumber" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Gebied</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-select class="w-full" v-model="area">
                        <vs-select-item v-for="item in areas" :key="item" :value="item" :text="item" />
                    </vs-select>
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Status</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-select class="w-full" v-model="status">
                        <vs-select-item value="0" text="Permanent gesloten" />
                        <vs-select-item value="1" text="Open" />
                        <vs-select-item value="2" text="Gesloten" />
                        <vs-select-item value="3" text="Tijdelijk gesloten" />
                        <vs-select-item value="4" text="Binnenkort beschikbaar" />
                    </vs-select>
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Banner</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="file" ref="banner" v-on:change="handleBannerUpload" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Logo</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="file" ref="logo" v-on:change="handleLogoUpload" />
                </div>
            </div>

        </vs-card>

        <vs-card v-if="staffRoute">

            <div class="vx-row">
                <div class="vx-col sm:w-2/3 w-full ml-auto">
                    <vs-button @click="companyCreated" class="mr-3 mb-2">Opslaan</vs-button>
                </div>
            </div>
        </vs-card>
  </div>-->

  <form-wizard
    color="rgba(var(--vs-primary), 1)"
    title="Bedrijf aanmaken"
    :subtitle="null"
    @on-complete="saveCompanyInfo"
    finishButtonText="Bedrijf aanmaken"
  >
    <tab-content title="Bedrijfsinformatie" class="mb-5" :before-change="validateStep1">
      <!-- tab 1 content -->
      <form data-vv-scope="step-1">
        <vx-card>
          <h2>Legale Informatie</h2>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input
                label="Naam"
                v-model="name"
                class="w-full"
                name="name"
                v-validate="'required'"
              />
              <span class="text-danger">{{ errors.first('step-1.name') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input
                label="Statutaire naam"
                v-model="legal_name"
                class="w-full"
                name="legal_name"
                v-validate="'required'"
              />
              <span class="text-danger">{{ errors.first('step-1.legal_name') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input
                type="text"
                label="KVK Nummer"
                v-model="coc"
                class="w-full"
                name="coc"
                v-validate="'required'"
              />
              <span class="text-danger">{{ errors.first('step-1.coc') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input
                      type="text"
                      label="BTW-nummer"
                      v-model="vat"
                      class="w-full"
                      name="vat"
                      v-validate="'required'"
              />
              <span class="text-danger">{{ errors.first('step-1.vat') }}</span>
            </div>
            <div class="vx-col w-full mt-5">
              <vs-input
                      type="text"
                      label="iBAN"
                      v-model="iban"
                      class="w-full"
                      name="iban"
                      v-validate="'required'"
              />
              <span class="text-danger">{{ errors.first('step-1.iban') }}</span>
            </div>
          </div>
        </vx-card>
        <div class="spacer"></div>
        <vs-card class="company-standard">
          <h2>Algemeen</h2>


          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Naam</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="name" />
            </div>
          </div>

          <div class="vx-row mb-6" v-if="staffRoute">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Slug</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="slug" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Email</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="email" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Financieel Email</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="financialemail" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Telefoonnummer</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="phonenumber" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Intern telefoonnummer</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" type="text" v-model="internalphonenumber" />
            </div>
          </div>

          <div class="vx-row mb-6" v-if="staffRoute">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Gebied</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-select class="w-full" v-model="area">
                <vs-select-item v-for="item in areas" :key="item" :value="item" :text="item" />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6" v-if="staffRoute">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Status</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-select class="w-full" v-model="status">
                <vs-select-item value="0" text="Permanent gesloten" />
                <vs-select-item value="1" text="Open" />
                <vs-select-item value="2" text="Gesloten" />
                <vs-select-item value="3" text="Tijdelijk gesloten" />
                <vs-select-item value="4" text="Binnenkort beschikbaar" />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6" v-if="staffRoute">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Banner</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <input
                class="vs-inputx vs-input--input normal hasValue w-full"
                type="file"
                ref="banner"
                v-on:change="handleBannerUpload"
              />
            </div>
          </div>

          <div class="vx-row mb-6" v-if="staffRoute">
            <div class="vx-col sm:w-1/3 w-full">
              <span class="float-right font-bold">Logo</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <input
                class="vs-inputx vs-input--input normal hasValue w-full"
                type="file"
                ref="logo"
                v-on:change="handleLogoUpload"
              />
            </div>
          </div>
        </vs-card>
        <div class="flex mb-4">
          <vx-card class="w-1/2 address-card">
            <h2>Bezoekadres</h2>

            <div class="vx-row">
              <div class="vx-col md:w-full mt-5">
                <vs-input label="Postcode" v-model="postcode" class="w-full" />
              </div>
              <div class="vx-col md:w-full mt-5">
                <vs-input type="text" label="Huisnummer" v-model="housenumber" class="w-full" />
              </div>
              <div class="vx-col md:w-full mt-5">
                <vs-input
                        type="text"
                        label="Adres"
                        v-model="address"
                        disabled="disabaled"
                        class="w-full"
                />
              </div>
            </div>
          </vx-card>

          <vx-card class="w-1/2 address-card">
            <h2>Factuuradres</h2>

            <div class="vx-row">
              <div class="vx-col md:w-full mt-5">
                <vs-input label="Postcode" v-model="postcode" class="w-full" />
              </div>
              <div class="vx-col md:w-full mt-5">
                <vs-input type="text" label="Huisnummer" v-model="housenumber" class="w-full" />
              </div>
              <div class="vx-col md:w-full mt-5">
                <vs-input
                        type="text"
                        label="Adres"
                        v-model="address"
                        disabled="disabaled"
                        class="w-full"
                />
              </div>
            </div>
          </vx-card>
        </div>
      </form>
    </tab-content>

    <tab-content title="Tijden & betaalmethodes" class="mb-5">
      <!-- tab 1 content -->
      <vs-card v-if="staffRoute">
        <div slot="header">
          <h2>Betaalmethodes</h2>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-2/3 w-full ml-auto" v-for="paymentMethod in availablepaymentMethods" :key="paymentMethod">
            <label>
              <input type="checkbox" class="inline-flex" v-model="paymentMethods" :name="paymentMethod.name" :value="paymentMethod.id" />
              {{ paymentMethod.name}}
            </label>
          </div>
        </div>

      </vs-card>

      <!-- tab 1 content -->
      <vs-card v-if="staffRoute">
        <div slot="header">
          <h2>Categorieën</h2>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-2/3 w-full ml-auto" v-for="category in availableCompanyCategories" :key="category">
            <label>
              <input type="checkbox" class="inline-flex" v-model="companyCategories" :name="category.name" :value="category.id" />
              {{ category.name}}
            </label>
          </div>
        </div>

      </vs-card>
      <vs-card v-if="staffRoute">
        <div slot="header">
          <h2>Openingstijden</h2>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="float-right font-bold">Maandag</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="monday" />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="float-right font-bold">Dinsdag</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="tuesday" />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="float-right font-bold">Woensdag</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="wednesday" />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="float-right font-bold">Donderdag</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="thursday" />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="float-right font-bold">Vrijdag</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="friday" />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="float-right font-bold">Zaterdag</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="saturday" />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span class="float-right font-bold">Zondag</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="sunday" />
          </div>
        </div>

      </vs-card>
    </tab-content>

    <!-- tab 3 content -->
    <tab-content title="Contact" class="mb-5">
      <!-- tab 1 content -->
      <vx-card>
        <h2>Contact</h2>


      </vx-card>
    </tab-content>
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { Validator } from "vee-validate";

let local = {
  custom: {
    name: {
      required: "Naam is vereist",
    },
    legal_name: {
      required: "Statutaire naam is vereist",
    },
    coc: {
      required: "KVK Nummer is vereist",
    },
    vat: {
      required: "BTW-nummer is vereist",
    },
    iban: {
      required: "iBAN is vereist",
    },
  },
};

Validator.localize("en", local);

export default {
  components: {
    FormWizard,
    TabContent,
  },
  mounted() {
    this.getPaymentMethods();
    this.getCompanyCategories();
  },
  data() {
    return {
      area: "Spijkenisse",
      coc: "",
      vat: "",
      iban: "",
      name: "",
      btwNumber: "",
      slug: null,
      legal_name: "",
      country: null,
      state: null,
      city: null,
      streetname: null,
      housenumber: "",
      postcode: "",
      email: null,
      address: "",
      financialemail: null,
      phonenumber: null,
      internalphonenumber: null,
      service: null,
      status: null,
      package: null,
      banner: null,
      logo: null,
      bannerString: null,
      logoString: null,
      openinghours: [],
      paymentMethods: [],
      availablepaymentMethods: [],
      oldSlug: null,
      areas: ["Spijkenisse", "Schiedam", "Ijsselmonde", "Delft"],
      monday: null,
      tuesday: null,
      wednesday: null,
      thursday: null,
      friday: null,
      saturday: null,
      sunday: null,
      availableCompanyCategories: [],
      companyCategories: []
    };
  },
  computed: {
    staffRoute() {
      if (this.$route.meta.staff) {
        if (localStorage.getItem("stafftoken") !== null) {
          return true;
        }
      } else {
        if (localStorage.getItem("stafftoken") !== null) {
          return true;
        }
        return false;
      }
    },
  },
  watch: {
    name: function () {
      const a =
        "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
      const b =
        "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
      const p = new RegExp(a.split("").join("|"), "g");
      this.slug = this.name
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, "");
    },
    housenumber: function () {
      if (this.housenumber === "") {
        this.address = "";
        return;
      }
      this.getAddress();
    },
  },
  methods: {
    getPaymentMethods: function () {
      this.$http
        .get("v1/paymentmethods", {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
          },
        })
        .then((response) => {
          this.availablepaymentMethods = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCompanyCategories() {
      this.$http
              .get("v1/company-categories", {
                headers: {
                  Authorization:
                          "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                },
              })
              .then((response) => {
                this.availableCompanyCategories = response.data;
              })
              .catch((error) => {
                console.log(error);
              });
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then((result) => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    saveCompanyInfo() {
      let formData = new FormData();

      formData.append("new", 1);
      formData.append("position", 0);
      formData.append("area", this.area);
      formData.append("banner", this.banner);
      formData.append("logo", this.logo);
      formData.append("chamber_of_commerce_number", this.coc);
      formData.append("vat_number", this.vat);
      formData.append("bank_account", this.iban);
      formData.append("name", this.name);
      formData.append(
        "slug",
        this.slug != this.oldSlug ? this.slug : this.oldSlug
      );
      formData.append("legal_name", this.legal_name);
      formData.append("country", this.country);
      formData.append("state", this.state);
      formData.append("city", this.city);
      formData.append("streetname", this.streetname);
      formData.append("housenumber", this.housenumber);
      formData.append("postal_code", this.postcode);
      formData.append("email", this.email);
      formData.append("finance_email", this.financialemail);
      formData.append("phone_number", this.phonenumber);
      formData.append("payment_methods", this.paymentMethods);
      formData.append("categories", this.companyCategories);
      formData.append("internal_phone_number", this.internalphonenumber);
      formData.append("service", this.service);
      formData.append("package_id", 12);
      formData.append("status", this.status);

      let token = this.staffRoute
        ? JSON.parse(localStorage.getItem("stafftoken"))
        : JSON.parse(localStorage.getItem("companytoken"));
      let url = this.staffRoute
        ? "https://staffapi.hebtrek.nl/v1/company/create"
        : "https://companyapi.hebtrek.nl/v1/company/" +
          this.$route.params.slug +
          "/info/update";
      this.$http
        .post(url, formData, {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.companyCreated();
        })
        .catch((error) => {
          this.$util.logError(error, this.$vs);
        });
    },
    getAddress: function () {
      if (this.housenumber === "") {
        console.log("empty");
        this.address = "";
        return;
      }
      this.$http
        .get(
          "https://staffapi.hebtrek.nl/v1/address?api_token=" +
            JSON.parse(localStorage.getItem("stafftoken")),
          {
            params: {
              zipcode: this.postcode,
              number: this.housenumber,
            },
          }
        )
        .then((response) => {
          this.address =
            response.data.street +
            " " +
            response.data.number +
            ", " +
            response.data.postcode +
            ", " +
            response.data.city;
          this.street = response.data.street;
          this.city = response.data.city;
        })
        .catch((error) => {
          // this.$util.logError(error, this.$vs);
        });
    },
    handleBannerUpload: function () {
      this.banner = this.$refs.banner.files[0];
    },
    handleLogoUpload: function () {
      this.logo = this.$refs.logo.files[0];
    },
    companyCreated() {
      this.$vs.notify({
        title: this.name + " aangemaakt",
        text: "Klik hier om verder te gaan!",
        color: "success",
        fixed: true,
        click: () => {
          this.$router.push("/companies/" + this.slug + "/dashboard");
        },
      });
    },
  },
};
</script>

<style>
.company-standard {
  margin-top: 50px;
}

.address-card {
  margin: 15px;
}
</style>
